import React, { Dispatch, SetStateAction, useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { LuMoreVertical } from "react-icons/lu";
import ModalImportExcel from "../../../components/common/modal/ModalImportExcel";
import ModalExportExcel from "../../../components/common/modal/ModalExportExcel";
import { GroupType } from "../../../types/group.type";

interface IOptions {
  group: GroupType;
  setLoad: Dispatch<SetStateAction<number>>;
}

function Options({ group, setLoad }: IOptions) {
  const [anchorMenu, setAnchorMenu] = useState<HTMLButtonElement | null>(null);
  const [openImportExcel, setOpenImportExcel] = useState(false);
  const [openExportExcel, setOpenExportExcel] = useState(false);

  const handleCloseMenu = () => {
    setAnchorMenu(null);
  };

  return (
    <>
      {openImportExcel && (
        <ModalImportExcel
          open={openImportExcel}
          handleClose={() => setOpenImportExcel(false)}
          apiCode={group?.apiCode}
          setLoad={setLoad}
          columns={group?.columns}
        />
      )}
      {openExportExcel && (
        <ModalExportExcel
          open={openExportExcel}
          handleClose={() => setOpenExportExcel(false)}
          apiCode={group?.apiCode}
          filenameExport={`${group?.apiCode}_export.xlsx`}
        />
      )}

      <Menu open={!!anchorMenu} anchorEl={anchorMenu} onClose={handleCloseMenu}>
        <MenuItem onClick={() => setOpenExportExcel(true)}>Xuất excel</MenuItem>
      </Menu>
      {/* Button */}
      <Button
        onClick={(e) => setAnchorMenu(e.currentTarget)}
        variant="contained"
        color="primary"
        size="small"
        sx={{
          boxShadow: "none",
          color: "common.white",
          textTransform: "none",
          "&:hover": { boxShadow: "none" },
        }}
        startIcon={<LuMoreVertical size={16} />}
      >
        Tùy chọn
      </Button>
    </>
  );
}

export default Options;
